import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-full-loading',
  templateUrl: './full-loading.component.html',
  styleUrls: ['./full-loading.component.scss']
})
export class FullLoadingComponent {
  @Input('active') active: any = false;

  constructor() { }

}
